import type { Hsb, RoundColor } from "../color";
import { hsbToHex } from "../color";
import { copy } from "../copy";
import { Controls } from "./Controls";
import { ToonCard } from "./ToonCard";

export function Stage({
  target,
  guess,
  onGuess,
  onSubmit,
  roundIndex,
  roundCount,
}: {
  target: RoundColor;
  guess: Hsb;
  onGuess: (next: Hsb) => void;
  onSubmit: () => void;
  roundIndex: number;
  roundCount: number;
}) {
  const guessHex = hsbToHex(guess);
  const isLast = roundIndex === roundCount - 1;
  return (
    <article className="stage play-stage" aria-label="라운드 화면">
      <section
        className="color-card target-card"
        style={{ background: target.hex }}
        aria-label={`${copy.target} – ${target.character} ${target.part}`}
      >
        <div className="card-overlay">
          <span className="pill">
            {roundIndex + 1} / {roundCount} {copy.round}
          </span>
          <p className="card-prompt">
            <b>{target.character}</b>
            <em>
              {target.part} {copy.promptSuffix}
            </em>
          </p>
        </div>
      </section>
      <section
        className="color-card guess-card"
        style={{ background: guessHex }}
        aria-label={copy.guess}
      >
        <div className="card-overlay card-overlay-top">
          <span className="pill ghost">{copy.guess}</span>
          <p className="hsb-readout" aria-live="polite">
            H {guess.hue} · S {guess.saturation} · B {guess.brightness}
          </p>
        </div>
        <div className="guess-panel">
          <Controls
            guess={guess}
            onGuess={onGuess}
            onSubmit={onSubmit}
            isLastRound={isLast}
          />
        </div>
      </section>
    </article>
  );
}

export function IntroStage() {
  return (
    <article className="stage intro-stage" aria-label="안내">
      <div className="prompt">
        <b>{copy.brand}</b>
        <span>{copy.introPrompt}</span>
      </div>
      <ToonCard
        target={{
          hue: 210,
          saturation: 60,
          brightness: 72,
          hex: "#5fa6d1",
          character: copy.brand,
          part: copy.introCta,
          shape: "star",
        }}
        label={copy.eyebrow}
      />
      <p className="round-score muted">{copy.introCta}</p>
    </article>
  );
}
